export default __webpack_public_path__ + "static/media/teacher2.bbf0352a.png";